import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  label: {
    display: 'inline-flex',
    alignItems: 'center'
  }
});
